import { Fragment } from 'react'

import * as storage from 'scripts/utils/storage'

const LoggedInBox = () => {
  const redirectUrl = target => {
    const currentUrl = encodeURIComponent(window.location.href)
    window.location = `/${target}?redirect=${currentUrl}`

    if (storage.has('employee-notification-dispatched')) {
      storage.remove('employee-notification-dispatched')
    }
  }

  return (
    <Fragment>
      <ul className="user-list">
        <li>
          <a href="/minha-conta">Meus dados</a>
        </li>
        <li>
          <a href="/meus-pedidos">Meus pedidos</a>
        </li>
        <li>
          <a href="/fidelidade">Programa de Fidelidade</a>
        </li>
        <li>
          <a href="/minhas-listas-de-desejos">Listas de favoritos</a>
        </li>
        <li>
          <a href="/meus-projetos">Meus projetos</a>
        </li>
      </ul>
      <div className="user-actions">
        <span className="user-actions-msg">Não é você?</span>
        <span className="user-actions-logout">
          <a onClick={() => redirectUrl('logout')}>Sair</a>
        </span>
      </div>
    </Fragment>
  )
}

export default LoggedInBox
